import "./FormStyles.css"

import React, { useRef, useState } from 'react'
import emailjs from '@emailjs/browser';


const Form = () => {
  const [buttonName, setButtonName] = useState("SUBMIT");
  const [buttonCLassName, setButtonClassName] = useState("btn");
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_t3tk08o', 'template_4tx1qbw', form.current, 'O9ttM5nj6UrCAK5gV')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      setButtonName("Email send ✓")
      e.target.reset();
  };
  
  const handleEmailSend = () => {
    setButtonClassName("email-send")
  }

  return (
    <div  className="form"> 
      
      <form ref={form} onSubmit={sendEmail}>
        <label>
            Full name            
        </label>  
        <input type="text" name="user_name" required />
        <label>
            Email            
        </label> 
        <input type="email" name="user_email" required /> 
        <label>
            Contact Number            
        </label>
        <input type="number" name="user_number" required/>
        <label>
            Message
        </label>
        <textarea rows="6" name="user_message" placeholder='Type your message here..' required/>
        
        <button type="submit" className={buttonCLassName} onClick={handleEmailSend}>{buttonName}</button>


      </form>      
    </div>
  )
}

export default Form
